// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimsList-cls1_ioc","cls2":"ClaimsList-cls2_FVz ClaimsList-cls1_ioc"};